<template>
	<div class="home-page">
		<!-- definePageMeta -->
		<Head>
			<Title>{{ pageMetaObject?.title ? ensureBrandSuffix(pageMetaObject.title) : `${$t('common.home_page')} | CarFree` }}</Title>
			<Meta name="description" :content="pageMetaObject?.description ?? ''" />
			<Meta v-if="config.public.isIndex" name="robots" :content="robotsCalculated" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link
				rel="canonical"
				:href="pageMetaObject?.canonical && pageMetaObject?.canonical?.trim() ? pageMetaObject?.canonical : `${url.origin}${url.pathname}`" />

			<!-- OG tags -->
			<Meta
				property="og:title"
				:content="pageMetaObject?.title ? ensureBrandSuffix(pageMetaObject.title) : `${$t('common.home_page')} | CarFree`" />
			<Meta property="og:description" :content="pageMetaObject?.description ?? ''" />
			<Meta
				property="og:url"
				:content="
					pageMetaObject?.canonical && pageMetaObject?.canonical?.trim() ? pageMetaObject?.canonical : `${url.origin}${url.pathname}`
				" />
			<Meta
				name="twitter:title"
				:content="pageMetaObject?.title ? ensureBrandSuffix(pageMetaObject.title) : `${$t('common.home_page')} | CarFree`" />
			<Meta name="twitter:description" :content="pageMetaObject?.description ?? ''" />
		</Head>

		<LazyIdleGlobalHeader booker hydrate-on-idle />
		<HomePageHero />
		<PromoBanners disableAos />
		<LazyGlobalNumberOneSection disableAos />
		<LazyTestimonials class="render-offscreen" />
		<LazyHomePageChooseCar class="render-offscreen" />
		<LazyGlobalSEOSection class="render-offscreen" :pageType="ECMSType.SUBPAGE" :page="ECMSPage.HOME" />
		<LazyHomePageContentSection class="render-offscreen" />
		<LazyGlobalDepartmentsSection
			class="render-offscreen"
			disableAos
			:title="isMobile_md ? $t('pages.index.branch_in_every_city') : $t('pages.index.branches_of_our_company')" />
		<LazyGlobalApplicationBanner class="render-offscreen" />
		<LazyGlobalNewsSection v-if="locale === 'pl'" class="render-offscreen" />
		<!-- <GlobalSEOSectionAccordion :pageType="ECMSType.SUBPAGE" :page="ECMSPage.HOME" /> -->
	</div>
</template>

<script setup lang="ts">
import { ECMSType, ECMSPage } from '@/modules/adminModule/constants/pagesCMSconstants'
const config = useNuxtApp().$config
const url = useRequestURL()
const { locale, t } = useI18n()

// Organization structured data (JSON-LD)
useJsonld(() => ({
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: 'CarFree',
	legalName: 'CarFree',
	url: url.origin,
	logo: `${url.origin}/logo-cf.svg`,
	image: `${url.origin}/car-free-1200x630.jpg`,
	description: t('pages.index.organization_structured_data_description'),
	vatID: '521 369 56 26',
	telephone: '+48 794 500 550',
	contactPoint: {
		'@type': 'ContactPoint',
		telephone: '+48 794 500 550',
		contactType: 'customer service',
		availableLanguage: ['pl', 'en'],
	},
	sameAs: [
		'https://www.facebook.com/CarFree.Wypozyczalnia.Aut',
		'https://www.instagram.com/carfree.wypozyczalnia',
		'https://www.tiktok.com/@carfree.pl',
	],
}))

const { loginByCode } = useOAuthCodeLogin()
const pageSectionsStore = usePageSectionsStore()

const pageSections = computed(() => pageSectionsStore.getPageSections)
const pageMetaObject = computed(() => pageSectionsStore.pageMetaObject)

const googleRatingsStore = useGoogleRatingsStore()
const trustpilotRatingsStore = useTrustpilotRatingsStore()

// Critical for initial render (above the fold)
await Promise.all([
	loginByCode(),
	pageSectionsStore.fetchPageSections(),
	googleRatingsStore.fetchGoogleRating(),
	trustpilotRatingsStore.fetchTrustpilotRating(),
])

provide('pageSections', pageSections)
const cookie = useCookie('cf-car')
cookie.value = null
const bookerTarget = ref<HTMLElement | null>(null)
provide('bookerTarget', bookerTarget)

const { isMobile_md } = useWindowWidth()

const isNavBookerVisible = ref()
provide('isNavBookerVisible', isNavBookerVisible)

// const resetData = () => {
// 	useReservationStore().deleteLocalStorage('cf_booker')
// 	location.reload()
// }

const robotsCalculated = useRobotsMeta(() => pageMetaObject.value?.robots)

usePageViewed(EGTMPageType.HOMEPAGE)

// const carsStore = useCarsStore()

// fetch data for cars page to load faster
// onMounted(() => {
// 	Promise.all([
// 		carsStore.fetchAllCars(),
// 		carsStore.fetchAllFilters(),
// 		carsStore.fetchAllSegments(),
// 		carsStore.fetchAllGroups(),
// 		locationsStore.fetchLocations(),
// 	])
// })

definePageMeta(pageMeta.HOME.HOME)
</script>
